import { NavLink } from "react-router";
import { KIND_META, MASTER_KINDS } from "@/components/admin/master-kinds";

const item = ({ isActive }: { isActive: boolean }) => `admin-nav-item${isActive ? " admin-nav-item-on" : ""}`;
const sub = ({ isActive }: { isActive: boolean }) => `admin-nav-item admin-nav-sub${isActive ? " admin-nav-item-on" : ""}`;

/** 관리자 왼쪽 메뉴 , 현황,가입자,마스터 데이터(종류별),변경 이력 */
export function AdminNav() {
  return (
    <nav className="admin-nav" aria-label="관리 메뉴">
      <NavLink to="/admin" end className={item}>현황</NavLink>
      <NavLink to="/admin/users" className={item}>가입자</NavLink>
      <span className="admin-nav-divider" aria-hidden="true" />
      <span className="admin-nav-group">마스터 데이터</span>
      {MASTER_KINDS.map((k) => (
        <NavLink key={k} to={`/admin/master/${k}`} className={sub}>
          {KIND_META[k].label}
        </NavLink>
      ))}
      <NavLink to="/admin/audit" className={item}>변경 이력</NavLink>
    </nav>
  );
}
